export {
  default as WorkflowRestrictionEditor,
  toWorkflowChips,
  type IWorkflowChip,
} from './WorkflowRestrictionEditor'

// Shared so the per-row cell and the bulk selection bar show identical wording.
export const DUPLICATE_WORKFLOW_SET_ERROR = 'Workflow set should be unique'
